import React from 'react';
import { Container, Grid } from '@material-ui/core';

import css from './ImageWithText.module.css';

const ImageWithText = (props) => {

    let elements = null;

    if (props.imgFirst) {
        elements = (
            <Grid container
                    justify="flex-start"
                    alignItems="center"
                    wrap="nowrap">
                    <img src={props.img} alt="ImageWithText" />
                    <span style={{ paddingLeft: '20px'}}>{props.children}</span>
                </Grid>
        );
    } else {
        elements = (
            <Grid container
                    justify="flex-end"
                    alignItems="center"
                    wrap="nowrap">
                    <span style={{ paddingRight: '20px'}}>{props.children}</span>
                    <img src={props.img} alt="ImageWithText" />
                </Grid>
        );
    }

    return (
        <div className={css.ImageWithText}>
            <Container maxWidth="md">
                {elements}
            </Container>
        </div>
    );
};

export default ImageWithText;